exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1AWybNeZ5IFOVYVj1Fy8nR{position:absolute;top:0;right:0;bottom:0;left:0;max-height:100vh;overflow:hidden;display:flex;flex-direction:column;justify-content:stretch}._1AWybNeZ5IFOVYVj1Fy8nR ._17IzdEh4fFsDQiu9pjOFRX{flex:1;position:relative;min-height:0}\n", ""]);

// Exports
exports.locals = {
	"NoScrollLayout": "_1AWybNeZ5IFOVYVj1Fy8nR",
	"content": "_17IzdEh4fFsDQiu9pjOFRX"
};